/**
 * Modules.Video-fill
    Fills up a space with an YouTube video
 */

import ResizeObserver from 'resize-observer-polyfill';

class VideoFill {

  init($el) {
    this.$el = $el;
    this.$iframe = $el.querySelector('.js--video-fill__wrap');

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.resizeFrame();
      }
    });
    resizeObserver.observe(this.$el);
  }

  resizeFrame() {
    const dim = this.$el.getBoundingClientRect();
    let newWidth = dim.width;
    let newHeight = dim.height;

    if (dim.height / dim.width > 9 / 16) {
      newWidth = dim.height / 9 * 16;
    } else {
      newHeight = dim.height / 9 * 16;
    }

    this.$iframe.style.width = `${newWidth}px`;
    this.$iframe.style.height = `${newHeight}px`;
  }
}

[...document.querySelectorAll('.js--video-fill')].forEach($el => {
  const inst = new VideoFill();
  inst.init($el);
});
